import LlamadaService from './llamada_service.js';
import ConfigService from './config_service.js';
import LoginService from './login_service.js';

const llamada = new LlamadaService();
const configService = new ConfigService();
const config = configService.getConfig();
const loginService = new LoginService();

export default class PacienteService {
	get(data) {
		data.action = 'get';
		data.countPacientes = false;
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'PacienteWebService.php?token='+token, data);
	}

	countPacientes(data) {
		data.countPacientes = true;
		data.action = 'get';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'PacienteWebService.php?token='+token, data);
	}

	save(data) {
		data.action = 'save';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'PacienteWebService.php?token='+token, data);
	}

	activate(data) {
		data.action = 'activate';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'PacienteWebService.php?token='+token, data);
	}

	deactivate(data) {
		data.action = 'deactivate';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'PacienteWebService.php?token='+token, data);
	}

	remove(data) {
		data.action = 'remove';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'PacienteWebService.php?token='+token, data);
	}

	getAntecedentesPaciente(data) {
		data.action = 'get-antecentes-paciente';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'PacienteWebService.php?token='+token, data);
	}

	formatPaciente(paciente) {
		return paciente.idPaciente  + " - " +paciente.nombrePaciente + " " + paciente.apellidoPaciente  + " - DNI: " + paciente.dniPaciente  
									+ " - EDAD: " + paciente.edadPaciente + " - HC: " + paciente.nroHcPaciente;
	}

	datosPersonalesPaciente(paciente) {
		return paciente.nombrePaciente + " " + paciente.apellidoPaciente  + ", DNI: " + paciente.dniPaciente
	}

	datosAdicionales(paciente) {
		return paciente.idPaciente  + " - " +paciente.nombrePaciente + " " + paciente.apellidoPaciente  + " - DNI: " + paciente.dniPaciente  
									+ " - EDAD: " + paciente.edadPaciente + " - HC: " + paciente.nroHcPaciente;
	}
}

